/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModelInteger
 */
export interface ModelInteger {
    /**
     * 
     * @type {number}
     * @memberof ModelInteger
     */
    integer: number;
}


/**
 * Check if a given object implements the ModelInteger interface.
 */
export function instanceOfModelInteger(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "integer" in value;

    return isInstance;
}

export function ModelIntegerFromJSON(json: any): ModelInteger {
    return ModelIntegerFromJSONTyped(json, false);
}

export function ModelIntegerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelInteger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integer': json['integer'],
    };
}

export function ModelIntegerToJSON(value?: ModelInteger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integer': value.integer,
    };
}

